import { InstagramChannelType } from './instagram-channel-type.enum';
import { RandomGenerator } from '../../../../test-utils';
var InstagramChannelDataBuilder = /** @class */ (function () {
    function InstagramChannelDataBuilder() {
        this.instagramChannelData = {
            messageId: RandomGenerator.randomId(),
            senderId: RandomGenerator.randomId(),
            instagramAccountId: RandomGenerator.randomId(),
            instagramChannelType: InstagramChannelType.DIRECT_MESSAGE,
        };
    }
    InstagramChannelDataBuilder.prototype.withMessageId = function (messageId) {
        this.instagramChannelData.messageId = messageId;
        return this;
    };
    InstagramChannelDataBuilder.prototype.withPageId = function (instagramAccountId) {
        this.instagramChannelData.instagramAccountId = instagramAccountId;
        return this;
    };
    InstagramChannelDataBuilder.prototype.withType = function (instagramChannelType) {
        this.instagramChannelData.instagramChannelType = instagramChannelType;
        return this;
    };
    InstagramChannelDataBuilder.prototype.withReplyTo = function (instagramReplyToInfo) {
        this.instagramChannelData.instagramReplyToInfo = instagramReplyToInfo;
        return this;
    };
    InstagramChannelDataBuilder.prototype.build = function () {
        return this.instagramChannelData;
    };
    return InstagramChannelDataBuilder;
}());
export { InstagramChannelDataBuilder };
//# sourceMappingURL=instagram-channel-data.builder.js.map